import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelSvg',
  props: {
  width: {
    type: [String, Number],
    default: 10,
  },
  height: {
    type: [String, Number],
    default: 10,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M1.26159 0.20768L4.99982 3.94591L8.72267 0.223063C8.78791 0.153619 8.86651 0.0980667 8.95374 0.0597365C9.04098 0.0214062 9.13506 0.00108789 9.23033 0C9.43433 0 9.62998 0.0810388 9.77423 0.225289C9.91848 0.369539 9.99952 0.565184 9.99952 0.769184C10.0013 0.863487 9.98381 0.957163 9.9481 1.04446C9.91239 1.13176 9.85921 1.21084 9.79184 1.27685L6.03053 4.9997L9.79184 8.76101C9.91861 8.88503 9.99295 9.05298 9.99952 9.23021C9.99952 9.43421 9.91848 9.62985 9.77423 9.7741C9.62998 9.91835 9.43433 9.99939 9.23033 9.99939C9.1323 10.0035 9.0345 9.9871 8.94313 9.95134C8.85177 9.91559 8.76883 9.86123 8.6996 9.79171L4.99982 6.05348L1.26928 9.78402C1.20429 9.85115 1.12664 9.90474 1.04083 9.94171C0.955021 9.97867 0.862738 9.99828 0.769309 9.99939C0.565309 9.99939 0.369664 9.91835 0.225414 9.7741C0.0811639 9.62985 0.000125151 9.43421 0.000125151 9.23021C-0.0016682 9.1359 0.0158285 9.04223 0.0515413 8.95493C0.0872541 8.86763 0.14043 8.78855 0.207805 8.72255L3.96911 4.9997L0.207805 1.23839C0.0810317 1.11436 0.00669369 0.946413 0.000125151 0.769184C0.000125151 0.565184 0.0811639 0.369539 0.225414 0.225289C0.369664 0.0810388 0.565309 0 0.769309 0C0.953913 0.00230755 1.13083 0.0769184 1.26159 0.20768Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})